<template>
  <div id="admin-occupation-setting">
    <!-- 职业技能等级设置 -->
    <diy_table
      :loading="loading"
      :searchData="searchData"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @handleClickTop="handleClickTop"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as occupationData from "./js/occupationStation.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      loading: false,
      searchData: occupationData.getSearchData("occupationStationSetting"),
      buttonList: occupationData.getTopButArray("occupationStationSetting"),
      tableMenu: occupationData.getTableMenu("occupationStationSetting"),
      tableData: [],
      tableButton: occupationData.getTableBUttonList(
        "occupationStationSetting"
      ),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempTip: {}, // 临时标签
      options: {
        professional: [],
      },

      dialogData: {
        flag: false,
        title: "添加子部门",
        width: "30%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_add_child_dep" },
          { text: "取消", active: "cancel" },
        ],
      },

      allAuthorityList: [],
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  考试管理 69
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "69" },
        });
        this.tableButton = base.returnAllButton(
          this.tableButton,
          resultData,
          "name"
        );
      } catch (error) {}
    },
    initTable(data) {
      try {
        this.loading = true;
        setTimeout(async () => {
          let requestData = {};
          let resultData = {};
          requestData = {
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
          };
          requestData = this.$baseData.array2json(data.searchData, requestData);
          resultData = await this.$request({
            url: "/occupationStation/getStationList",
            method: "post",
            data: requestData,
          });
          this.pageData.total = resultData.total;
          this.tableData = resultData.tableData;
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    handleClickTop(active) {
      switch (active) {
        case "create":
          // 创建职业技能等级标签
          this.tempTip = { id: "" };
          this.dialogData.title = "添加职业技能等级";
          this.dialogData.dialogData = [
            { title: "职业技能等级", type: "input", value: "", key: "name" },
            { title: "等级描述", type: "input", value: "", key: "des" },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_add" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;

        default:
          break;
      }
    },
    /**
     * 表格按钮操作
     */
    handleClick(data) {
      this.tempTip = JSON.parse(JSON.stringify(data.item));
      switch (data.active) {
        case "edit":
          //   编辑标签
          this.dialogData.title = "编辑职业技能等级";
          this.dialogData.dialogData = [
            {
              title: "职业技能等级",
              type: "input",
              value: this.tempTip.name,
              key: "name",
            },
            {
              title: "等级描述",
              type: "input",
              value: this.tempTip.des,
              key: "grade",
            },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_add" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "delete":
          //   删除标签
          this.$confirm("此操作将永久删除该标签, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let url = this.active == "/occupationStation/delStation"; // 删除职业技能等级
              let resultData = await this.$request({
                url: url,
                method: "post",
                data: { id: this.tempTip.id },
              });
              this.$message({
                type: "success",
                message: "删除成功!",
              });

              await this.initTable({
                pageData: this.pageData,
                searchData: this.searchData,
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
          break;

        default:
          break;
      }
    },
    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      try {
        let requestData = {};
        let resultData = {};
        switch (active) {
          case "makesure_add":
            // 编辑或添加职业技能等级标签
            requestData = {
              id: this.tempTip.id,
            };
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            if (requestData.name == "") {
              throw { message: "等级不可为空!" };
            }
            resultData = await this.$request({
              url: "/occupationStation/saveStation",
              method: "post",
              data: requestData,
            });
            this.$message({
              message: "添加成功!",
              type: "success",
              duration: 1000,
            });
            this.dialogData.flag = false;
            await this.initTable({
              pageData: this.pageData,
              searchData: this.searchData,
            });
            break;
          case "cancel":
            // 关闭弹出框
            this.colseDialog();
            break;
          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#admin-occupation-setting {
  width: 100%;
  height: 100%;
}
</style>